import type { GridColDef } from '@mui/x-data-grid';
import { formatPrice } from '@vy/services';
import { CURRENCIES, type CreditLedgerEntryOverview } from '@vy/types';
import { isNotNullOrUndefined, isPositive, vyDate, type ValueOf } from '@vy/utils';
import { formatDate } from '../../../../../utils/date';
import { CreditLedgerTableDotMenu } from './components/CreditLedgerTableDotMenu';

export const CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS = Object.freeze({
  DATE: 'date',
  INVOICE_NUMBER: 'invoiceNumber',
  DEBIT_AMOUNT: 'debitAmount',
  CREDIT_AMOUNT: 'creditAmount',
  BALANCE: 'balance',
  DOTS_MENU: 'dotsMenu',
});

export type CreditLedgerOverviewColumnsKey = ValueOf<typeof CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS>;

export const CREDIT_LEDGER_OVERVIEW_TABLE_COLUMNS: GridColDef<CreditLedgerEntryOverview>[] = [
  {
    field: CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS.DATE,
    sortable: false,
    headerName: 'Date',
    flex: 1,
    valueGetter: (_value, row) => formatDate(vyDate(row.date)),
  },
  {
    field: CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS.INVOICE_NUMBER,
    sortable: false,
    headerName: 'Invoice No.',
    flex: 1,
  },
  {
    field: CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS.CREDIT_AMOUNT,
    sortable: false,
    headerName: 'Credit',
    flex: 1,
    valueGetter: (_value, row) =>
      isNotNullOrUndefined(row.creditAmount) ? formatPrice(row.creditAmount, CURRENCIES.Usd, 0, 0) : null,
  },
  {
    field: CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS.DEBIT_AMOUNT,
    sortable: false,
    headerName: 'Debit',
    flex: 1,
    valueGetter: (_value, row) =>
      isNotNullOrUndefined(row.debitAmount) ? formatPrice(row.debitAmount, CURRENCIES.Usd, 0, 0) : null,
  },
  {
    field: CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS.BALANCE,
    sortable: false,
    headerName: 'Balance',
    flex: 1,
    valueGetter: (_value, row) => formatPrice(row.balance, CURRENCIES.Usd, 0, 0),
  },
  {
    field: CREDIT_LEDGER_OVERVIEW_COLUMNS_KEYS.DOTS_MENU,
    headerName: '',
    width: 50,
    sortable: false,
    renderCell: ({ row }) => (
      <CreditLedgerTableDotMenu
        creditLedgerId={row.id}
        downloadCreditNoteDisabled={isNotNullOrUndefined(row.debitAmount)}
        enableSyncToNetSuite={row.isInvoiceExportedToNetSuite && isPositive(row.creditAmount)}
      />
    ),
  },
];
